"use strict";
exports.__esModule = true;
exports.chart_bullet_comparative_measure_error_stroke_Color = {
  "name": "--pf-chart-bullet--comparative-measure--error--stroke--Color",
  "value": "#c9190b",
  "var": "var(--pf-chart-bullet--comparative-measure--error--stroke--Color, #c9190b)"
};
exports["default"] = exports.chart_bullet_comparative_measure_error_stroke_Color;